// ─── CENTRALIZED STORE — INITIAL STATE ──────────────────────────────────────
// [ARCH-P4] v91: Replaces 60+ useState declarations.
// All state consolidated here. Refs stay as refs in the component.

import {
  DEFAULT_LINKEDIN_PARAMS,
  DEFAULT_CAROUSEL_PARAMS,
  DEFAULT_BLOG_PARAMS,
  DEFAULT_EMAIL_PARAMS,
  DEFAULT_LANDING_PARAMS,
  DEFAULT_ADS_PARAMS,
  DEFAULT_CASE_STUDY_PARAMS,
} from '../constants/defaultParams.js';

export const createInitialState = () => ({
  // ── UI Slice ──────────────────────────────────────────────────────────────
  activeMode: 'linkedin-post',
  isDarkMode: false,
  generatedMode: null,
  wizardStep: 1,
  confirmedOutput: null,
  isLoading: false,
  loadingKey: 0,
  error: null,
  copiedId: null,
  pipelineProgress: null,  // { slots, activePhase, isComplete, isError, errorMessage, slotTimings }
  suggestProgress: null,  // same shape as pipelineProgress: { slots, activePhase, isComplete, ... }

  // ── Tenant (hidden — will be backend-managed after login) ────────────────
  tenant: 'alens',

  // ── Input Slice ───────────────────────────────────────────────────────────
  focusTopic: '',
  keyPoints: '',
  taskText: '',        // v96: raw task input
  taskContract: null,  // v96: parsed TaskContract (or null)
  socialChannel: 'instagram', // v108
  emailChannel: 'email-classic', // v112
  contentFormat: 'post',          // v109: 'post' | 'carousel'
  persona: 'cmo-marketing-leader',
  tone: 'professional-conversational',
  customTone: '',
  objective: 'customer-engagement',
  ctaUrl: '',
  ctaText: '',
  referenceUrls: ['', '', ''],

  // ── Search Config Slice ─────────────────────────────────────────────────
  searchEnabled: false,
  webSearch: {
    enabled: false,
    query: '',
    useForGeneration: true,
    generationResults: 3,
  },
  kbSearch: {
    enabled: true,
    query: '',
    useForGeneration: true,
    generationResults: 3,
  },

  // ── Refs Slice ──────────────────────────────────────────────────────────
  refsEnabled: false,
  userKbEnabled: false,
  userKbQuery: '',           // search query override for ephemeral bundle

  // ── Upload Bundle Slice ─────────────────────────────────────────────────
  uploadBundle: {
    files: [],        // [{ filename, chunks?, size? }]
    isLoading: false,
    error: null,
  },

  // ── Output Slice ──────────────────────────────────────────────────────────
  outputHistory: [],
  contentMemory: [],
  editingEntryId: null,
  editedContent: {},
  editValidationStatus: {},

  // ── Mode Params Slice ─────────────────────────────────────────────────────
  linkedInParams:   { ...DEFAULT_LINKEDIN_PARAMS },
  carouselParams:   { ...DEFAULT_CAROUSEL_PARAMS },
  blogParams:       { ...DEFAULT_BLOG_PARAMS },
  emailParams:      { ...DEFAULT_EMAIL_PARAMS },
  landingParams:    { ...DEFAULT_LANDING_PARAMS },
  adsParams:        { ...DEFAULT_ADS_PARAMS },
  caseStudyParams:  { ...DEFAULT_CASE_STUDY_PARAMS },
  sitemapUrl: '',
});
